<rid-algorithm class="h-dvh" (finished)="$router.navigate(['/mechanics'])" />
